import React, { Component } from "react";
import * as pdfjsLib from "pdfjs-dist";
import PDFJSWorker from 'pdfjs-dist/build/pdf.worker.entry'
import "./pdfviewer.css";
import { Icon, IconButton } from "@material-ui/core";
pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJSWorker  ;

export default class pdfViewer extends Component {
  state = {
    zoom: 1.0,
    page: 1,
    maxPages: 1,
    width: 800,
    height: 800,
    pdf: false,
  };

  async componentDidMount() {
    let pdf = await pdfjsLib.getDocument(this.props.pdfUrl);
    pdf = await pdf.promise;
    this.setState({ pdf, maxPages: pdf.numPages }, () => { this.renderPDF() })
  }

  zoom = (type) => {
    if (type === "in") {
      if (this.state.zoom >= 4.0) return;
      this.setState(
        {
          zoom: parseFloat((this.state.zoom + 0.25).toFixed(2)),
        },
        () => {
          this.renderPDF();
        }
      );
    } else if (type === "out") {
      if (this.state.zoom <= 0.5) return;
      this.setState(
        {
          zoom: parseFloat((this.state.zoom - 0.25).toFixed(2)),
        },
        () => {
          this.renderPDF();
        }
      );
    }
  };

  page = (type) => {
    const { page, maxPages } = this.state;
    if (type === 'back') {
      if(page === 1) return;

      this.setState({ page: page - 1 }, () => {
        this.renderPDF();
      });
    } else {
      if((page + 1) > maxPages) return;
      this.setState({ page: page  + 1 }, () => {
        this.renderPDF();
      });
    }
  }

  renderPDF() {
    try { 
      const { pdf, zoom, page } = this.state;
      if (pdf) {
        pdf.getPage(page).then((pagePdf) => {
          var canvas = document.getElementById("pdf_renderer");
          var ctx = canvas.getContext("2d");
          var viewport = pagePdf.getViewport({ scale: zoom });
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          pagePdf.render({
            canvasContext: ctx,
            viewport: viewport,
          });
        });
      } 
    } catch (error) {
      console.error(error)
    }
  }

  render() {
    const { page, maxPages, zoom } = this.state;
    const { minWidth } = this.props;

    return (
      <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', position: 'relative' }} >
        <style>{`
          .pdf-floating-toolbar {
            position: absolute;
            top: 16px;
            z-index: 20;
            display: flex;
            flex-direction: row;
            align-items: center;
            background: rgba(255, 255, 255, 0.85) !important;
            backdrop-filter: blur(8px) !important;
            -webkit-backdrop-filter: blur(8px) !important;
            border: 1px solid rgba(229, 231, 235, 0.9) !important;
            border-radius: 9999px !important;
            padding: 4px 12px !important;
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
          }
          .pdf-floating-toolbar .MuiIconButton-root {
            padding: 6px !important;
            color: #4b5563 !important;
          }
          .pdf-floating-toolbar .MuiIconButton-root:hover {
            background-color: rgba(243, 244, 246, 0.8) !important;
          }
          #canvas_container {
            width: 100%;
            height: 100%;
            overflow: auto;
          }

          /* Standardization for all PDF viewers inside a Material UI DialogContent */
          .MuiDialogContent-root:has(.pdf-viewer) {
            overflow: hidden !important;
            padding: 16px 24px !important;
          }
          .MuiDialogContent-root .pdf-viewer {
            height: 480px !important;
            max-height: 65vh !important;
            width: 100% !important;
            min-width: 0 !important;
            overflow: hidden !important;
            position: relative !important;
            display: flex !important;
            flex-direction: column !important;
            margin-bottom: 12px !important;
          }
          .MuiDialogContent-root .pdf-viewer > div {
            width: 100% !important;
            height: 100% !important;
            min-width: 0 !important;
            display: flex !important;
            flex-direction: column !important;
          }
          .MuiDialogContent-root #canvas_container {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            flex: 1 !important;
            height: auto !important;
            background: #f3f4f6 !important;
            border: 1px solid #e5e7eb !important;
            border-radius: 8px !important;
            overflow: auto !important;
            padding: 16px 0 !important;
            text-align: center !important;
          }
          .MuiDialogContent-root canvas {
            margin: 0 auto !important;
            display: block !important;
            box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
            border-radius: 6px !important;
            border: 1px solid #e5e7eb !important;
            background: #ffffff !important;
          }
        `}</style>
        
        {/* Floating Toolbar */}
        <div className="pdf-floating-toolbar">
          {/* Navigation */}
          <IconButton
            size="small"
            onClick={() => this.page("back")}
            disabled={page === 1}
            title="Página Anterior"
          >
            <Icon style={{ fontSize: '18px' }}>navigate_before</Icon>
          </IconButton>
          <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#4b5563', minWidth: '42px', textAlign: 'center', userSelect: 'none' }}>
            {page} / {maxPages}
          </span>
          <IconButton
            size="small"
            onClick={() => this.page("next")}
            disabled={page === maxPages}
            title="Siguiente Página"
          >
            <Icon style={{ fontSize: '18px' }}>navigate_next</Icon>
          </IconButton>

          {/* Separator */}
          <div style={{ width: '1px', height: '16px', backgroundColor: '#d1d5db', margin: '0 6px' }}></div>

          {/* Zoom Out */}
          <IconButton
            size="small"
            onClick={() => this.zoom("out")}
            disabled={zoom <= 0.5}
            title="Alejar"
          >
            <Icon style={{ fontSize: '18px' }}>zoom_out</Icon>
          </IconButton>
          <span style={{ minWidth: '40px', textAlign: 'center', fontSize: '11px', fontWeight: 'bold', color: '#4b5563', userSelect: 'none' }}>
            {Math.round(zoom * 100)}%
          </span>
          {/* Zoom In */}
          <IconButton
            size="small"
            onClick={() => this.zoom("in")}
            disabled={zoom >= 4.0}
            title="Acercar"
          >
            <Icon style={{ fontSize: '18px' }}>zoom_in</Icon>
          </IconButton>
        </div>

        {/* Canvas container */}
        <div 
          id="canvas_container" 
          style={{ minWidth }}
        >
          <canvas id="pdf_renderer"></canvas>
        </div>
      </div>
    );
  }
}
